import {Owner} from "./owner.model";
import {PageInfo} from "./page.model";

export interface CatalogCategories {
  id: string;
  parentId: string;
  name: string;
  photoId: string;
  itemsCount: number;
}
export interface CatalogFind {
  items: CatalogFindItem[] | [];
  pageInfo: PageInfo;
}
export interface CatalogFindItem {
  id: string;
  name: string;
  size: string;
  lease: number;
  deposit: number;
  photosIds: string[] | [];
  bookFrom: Date;
  rentFrom: Date;
  rentTo: Date;
  isFavorite: boolean;
}
export interface CatalogFindReq {
  categoryId?: string | null;
}
export interface CatalogItem {
  id: string;
  name: string;
  size: string;
  lease: number;
  deposit: number;
  photosIds: string[] | [];
  owner: Owner
}
export interface CatalogItemSchedule {
  id: string;
  name: string;
  size: string;
  lease: number;
  deposit: number;
  photosIds: string[] | [];
  owner: Owner
}
export interface CatalogByOwner {
  id: string;
  name: string;
  size: string;
  lease: number;
  deposit: number;
  photosIds: string[] | [];
  bookFrom: Date;
  rentFrom: Date;
  rentTo: Date;
  isFavorite: boolean;
}
export enum PropertyType {
  None,
  Text,
  Number,
  Range,
  Select,
  Textarea
}
